import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import { IconButton } from "@mui/material";

const SearchBar = ({ id, label, value, onChange, ...rest }) => {
    const [searchInput, setSearchInput] = useState(value);
    const [isSearching, setIsSearching] = useState(true);

    let previousLength = 0;
    useEffect(() => {
        const timer = setInterval(() => {
            const currentLength = searchInput?.length;
            if (searchInput === 0) setIsSearching(false);
            else if (currentLength !== previousLength) {
                setIsSearching(true);
            } else {
                setIsSearching(false);
            }
            previousLength = currentLength;
        }, 700);
        return () => {
            clearInterval(timer);
        };
    }, [searchInput]);

    const handleTheSearching = (event) => {
        const searchText = event.target.value;
        setSearchInput(searchText);
        onChange({ id: id, value: searchText });
    };

    return (
        <TextField
            {...rest}
            id={id}
            placeholder={"Keyword Search"}
            value={searchInput}
            onChange={handleTheSearching}
            sx={{ backgroundColor: "#FFFFFF" }}
            inputProps={{
                style: {
                    padding: 1,
                    fontSize: "0.85rem",
                },
            }}
            InputProps={{
                ...rest,
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon sx={{ color: "#000", marginLeft: "5px" }} />
                    </InputAdornment>
                ),
                disableUnderline: true,
            }}
        />
    );
};

export { SearchBar };
